import React from 'react';
import { Box, Chip, FormControl, Grid, IconButton, InputLabel, MenuItem, Paper, Select, Typography, } from '@mui/material';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { SearchControlsLayout, SearchTextField } from '../common';
import { COUPON_DISCOUNT_TYPES, COUPON_STATUS_TYPES } from '../../types/coupon';

interface CouponSearchFormProps {
  searchTerm: string;
  selectedStatus: string;
  selectedDiscountType: string;
  totalCount: number;
  expanded: boolean;
  onSearchChange: (value: string) => void;
  onStatusChange: (value: string) => void;
  onDiscountTypeChange: (value: string) => void;
  onSearch: () => void;
  onClearFilters: () => void;
  onClearSearch: () => void;
  onToggleExpand: () => void;
}

const CouponSearchForm: React.FC<CouponSearchFormProps> = ({
  searchTerm,
  selectedStatus,
  selectedDiscountType,
  totalCount,
  expanded,
  onSearchChange,
  onStatusChange,
  onDiscountTypeChange,
  onSearch,
  onClearFilters,
  onClearSearch,
  onToggleExpand,
}) => {
  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    onSearch();
  };

  // アクティブなフィルターをカウント
  const activeFilterCount = [
    searchTerm,
    selectedStatus,
    selectedDiscountType,
  ].filter(Boolean).length;

  return (
    <Paper
      component="form"
      elevation={2}
      sx={{ p: 3, mb: 3 }}
      onSubmit={handleSubmit}
    >
      {/* ヘッダー部分（常に表示） */}
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: expanded ? 2 : 0 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Typography variant="h6">{expanded ? '検索条件' : '検索'}</Typography>
            <IconButton onClick={onToggleExpand} size="small">
              {expanded ? <ExpandLess /> : <ExpandMore />}
            </IconButton>
          </Box>
          {!expanded && activeFilterCount > 0 && (
            <Chip
              label={`${activeFilterCount}件のフィルター適用中`}
              size="small"
              color="primary"
              variant="outlined"
            />
          )}
        </Box>
      </Box>

      {/* 折りたたみ可能な検索フォーム部分 */}
      <Box
        sx={{
          overflow: 'hidden',
          transition: 'max-height 0.3s ease-in-out',
          maxHeight: expanded ? '500px' : '0px',
        }}
      >
        <Grid container spacing={2} sx={{ mb: 2 }}>
          <Grid item xs={12} md={3}>
            <SearchTextField
              label="クーポン名・コード"
              value={searchTerm}
              onChange={(e) => onSearchChange(e.target.value)}
              onClear={onClearSearch}
            />
          </Grid>

          <Grid item xs={12} md={3}>
            <FormControl fullWidth size="small">
              <InputLabel id="status-filter-label">ステータス</InputLabel>
              <Select
                labelId="status-filter-label"
                id="status-filter"
                value={selectedStatus}
                onChange={(e) => onStatusChange(e.target.value)}
                label="ステータス"
              >
                <MenuItem value="">すべて</MenuItem>
                {Object.entries(COUPON_STATUS_TYPES).map(([ value, label ]) => (
                  <MenuItem key={value} value={value}>
                    {label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={3}>
            <FormControl fullWidth size="small">
              <InputLabel id="discount-type-filter-label">割引タイプ</InputLabel>
              <Select
                labelId="discount-type-filter-label"
                id="discount-type-filter"
                value={selectedDiscountType}
                onChange={(e) => onDiscountTypeChange(e.target.value)}
                label="割引タイプ"
              >
                <MenuItem value="">すべて</MenuItem>
                {Object.entries(COUPON_DISCOUNT_TYPES).map(([ value, label ]) => (
                  <MenuItem key={value} value={value}>
                    {label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>

        <SearchControlsLayout
          count={totalCount}
          onClear={onClearFilters}
        />
      </Box>
    </Paper>
  );
};
export default CouponSearchForm;
